import { Component, HostListener } from '@angular/core';
import { environment } from '../environments/environment';
import { SITE_SETTINGS, LocalStorageWrapper, SiteSettings, SignalRService, CurrentTabPageStorageWrapper } from 'lib/Vestra.shared';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
declare var $: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    get isVisibleBackButton(): boolean {
        const url = this.router.url;

        if (url === '/home' || url.startsWith('/authentication/')) {
            return false;
        } else {
            return true;
        }
    }

    constructor(private router: Router, private location: Location, /*private signalRService: SignalRService */) {}

    title = 'Vestra.admin-site';
    version = `Vestra Admin ${environment.version}`;
    footerText = `Vestra. ${new Date().getFullYear()} `;

    private initialMenuHeight: number | null = null;

    ngOnInit() {
        const siteSettings: SiteSettings = { isPublicSite: false };
        LocalStorageWrapper.setObject<SiteSettings>(SITE_SETTINGS, siteSettings);

        CurrentTabPageStorageWrapper.signalRChannelId = crypto.randomUUID();
        /* this.signalRService.startConnection(CurrentTabPageStorageWrapper.signalRChannelId);  */
    }

    ngAfterViewChecked(): void {
        this.checkTabsVisibility();
        this.setFixedBlockPosition();
    }

    @HostListener('window:resize')
    onResize() {
        this.setFixedBlockPosition();
    }

    public setFixedBlockPosition() {
        let menu = (document.querySelector('.navbar .navbar-brand') as HTMLElement) || (document.querySelector('.navbar .container-fluid') as HTMLElement);
        let fixedBlocks = document.querySelectorAll('.fixed-block') as NodeListOf<HTMLElement>;

        if (!menu || fixedBlocks.length === 0) {
            return;
        }

        let collapsedHeight = menu.offsetHeight;
        this.initialMenuHeight = collapsedHeight;
        fixedBlocks.forEach(block => {
            block.style.top = this.initialMenuHeight + 'px';
        });
    }

    public showVersionInfo() {
        this.router.navigate(['/administration/versioninfo']);
    }

    public goBack() {
        this.location.back();
    }

    private checkTabsVisibility(): void {
        if ($('.nav-pills').length) {
            $('#back-btn').css('bottom', '60px');
        } else {
            $('#back-btn').css('bottom', '20px');
        }
    }
}
